import { render } from "./ReservedLockers.vue?vue&type=template&id=2a0c6b4e&scoped=true&ts=true"
import script from "./ReservedLockers.vue?vue&type=script&lang=ts"
export * from "./ReservedLockers.vue?vue&type=script&lang=ts"

import "./ReservedLockers.vue?vue&type=style&index=0&id=2a0c6b4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0c6b4e"]])

export default __exports__